import { Box, useTheme } from "@mui/material"
import { yesNoToggleSx } from "./styles"

export const YesNoToggle = ({ value, onChange }) => {
  const theme = useTheme()
  const primary = theme.palette.primary.main
  return (
    <Box display="flex"  border={`1px solid ${primary}`} borderRadius="4px" overflow="hidden" width="100px" sx={yesNoToggleSx.container}>
      <Box
        flex={1}
        textAlign="center"
        p={1}
        sx={{
          ...yesNoToggleSx.yesBox,
           backgroundColor: value ? primary : 'white',
          color: value ? 'white' : 'inherit',
        }}
        onClick={() => onChange(true)}
      >
        YES
      </Box>
      <Box
        flex={1}
        textAlign="center"
        p={1}
        sx={{
          ...yesNoToggleSx.noBox,
          backgroundColor: !value ? primary : 'white',
          color: !value ? 'white' : 'inherit',
          borderLeft: `1px solid ${primary}`
        }}
        onClick={() => onChange(false)}
      >
        NO
      </Box>
    </Box>
  )
}